import { ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { ISiteNameWithId } from '../../siteManagement/serverApi/types/ISiteNameWithId';

export interface SiteRolesPickerContainerEmptyTemplateProps {
    actionHandler: () => void;
    title: string;
    actionTitle: string;
    siteNames: ISiteNameWithId[];
}

export class SiteRolesPickerContainerEmptyTemplate extends React.Component<SiteRolesPickerContainerEmptyTemplateProps, {}> {
    public render() {
        if (!this.props.siteNames || this.props.siteNames.length === 0) {
            return (<span/>);
        } else if (this.props.siteNames) {
            return (
                <div className="tb-site-membership-grid-empty">
                    <div className="tb-data-grid-no-matching-results">
                        {this.props.title}
                    </div>
                    <ButtonWidget onClick={this.props.actionHandler}>{this.props.actionTitle}</ButtonWidget>
                </div>
            );
        }
    }
}
